const FormDateFieldsAsTextFields = "/rslsitecoreapi/metadata/formdatefieldsastextfields";
var dateRegEx = /^[0-9]{4}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$/;

const renderFields = {
  Date() {
    fetch(document.location.origin + FormDateFieldsAsTextFields).then((response) => {
      return response !== null ? response.json() : null;
    }).then((res) => {
      var dateFields = (res !== null && res.ids) ? res.ids.split('|') : '';
      for (var i = 0; i < dateFields.length; i++) {
        var datepickerDOB = $('input[id*=' + dateFields[i] + '].datepicker');
        var inputDOBId = "dob-input-" + dateFields[i];
        if (datepickerDOB !== null && datepickerDOB.length === 1) {
          datepickerDOB.hide();
          var datePickerDefaultValue = $(datepickerDOB).prop("defaultValue")
          var label = $("label[for='" + $(datepickerDOB).attr('id') + "']");
          label.removeAttr("for").attr("for", inputDOBId);
          var inputDOB = $('<input type="text" id="' + inputDOBId + '" maxlength="10" ' +
            'name = "' + inputDOBId +
            '" class= "form-control text-box single-line dob-input-mask-field-datepicker" > ');
          $(datepickerDOB).before(inputDOB);
          if ($(datepickerDOB).is(':disabled')) {
            inputDOB.attr('disabled', true);
          }

          inputDOB.on("invalid", { inputDate: inputDOB[0] }, function (e) {
            if ($(e.data.inputDate).siblings('span.help-block').length > 0 &&
              $(e.data.inputDate).siblings('label.control-label').length > 0 && !$(e.data.inputDate).is(':disabled')) {
              $(e.data.inputDate).siblings('span.help-block')
                .html('<span class="field-validation-error">'
                + $(e.data.inputDate).siblings('label.control-label').text() + ' is required.</span>');
            }
          })
          var hasAttrib = $(datepickerDOB).attr('data-val-required');
          if (typeof hasAttrib !== 'undefined' && hasAttrib !== false) {
            inputDOB.attr('data-val-required', 'This field is required.')
              .attr('required', true).attr('data-val', true);
          } else {
            inputDOB.attr('data-val-required', inputDOB.siblings('label.control-label').text() + ' is required')
            $(datepickerDOB).attr('data-val-required', inputDOB.siblings('label.control-label').text() + ' is required')
          }
          if (datePickerDefaultValue !== undefined && datePickerDefaultValue !== '') {
            $(datepickerDOB).val(datePickerDefaultValue);
            var datePickDefValueArr = datePickerDefaultValue.split("-");
            if (datePickDefValueArr !== null && datePickDefValueArr.length === 3)
              $(inputDOB).val(datePickDefValueArr[2] + '/' + datePickDefValueArr[1] + '/' + datePickDefValueArr[0]) //re-arranged date as 'dd/mm/yyyy';
          }
          let parentEl = inputDOB.parent();
          if (inputDOB.val() === null || inputDOB.val() === '') {
            parentEl.addClass('empty');
            inputDOB.removeAttr('placeholder')
          }
          inputDOB.on('focus', { parentEl: parentEl, inputDate: inputDOB[0] }, (e) => {
            $(e.data.parentEl).removeClass('empty');
            $(e.data.inputDate).attr('placeholder','DD/MM/YYYY')
          });
          inputDOB.on('keypress', { parentEl: parentEl, inputDate: inputDOB[0] }, (e) => {
            $(e.data.parentEl).removeClass('empty');
            $(e.data.inputDate).attr('placeholder', 'DD/MM/YYYY')
          });
          inputDOB.on('blur', { parentEl: parentEl, inputDate: inputDOB[0], datepicker: datepickerDOB[0]}, (e) => {
            if ($(e.data.inputDate).val() === null || $(e.data.inputDate).val() === '') {
              $(e.data.parentEl).addClass('empty');
              $(e.data.inputDate).removeAttr('placeholder')
            }
            setDOBValue(e.data.inputDate, e.data.datepicker);
          });
          inputDOB.on('input', { inputDate: inputDOB[0], datepicker: datepickerDOB[0] }, (e) => {
            maskDate(e.data.inputDate);
            setDOBValue(e.data.inputDate, e.data.datepicker);
          });
        }
      }
    }).catch(() => {
    });
  }
}

var dobPreValue = "";
function maskDate(elem) {
  var cursorPos = elem.selectionStart;
  var inputValue = elem.value;
  var inputValuelength = inputValue.length;
  var dobPreValuelength = dobPreValue.length;
  if (inputValue[0] !== '0' && inputValue[1] === '/' && inputValue.length === 2) {
    elem.value = "0" + inputValue;
    cursorPos = inputValuelength > dobPreValuelength ? cursorPos + 1 : cursorPos;
  } else if (inputValue[2] === '/' && inputValue[3] !== '0' && inputValue[4] === '/' && inputValue.length === 5) {
    elem.value = inputValue.slice(0, 3) + "0" + inputValue.slice(3);
    cursorPos = inputValuelength > dobPreValuelength ? cursorPos + 1 : cursorPos;
  } else {
    let v = elem.value.replace(/\D/g, '').slice(0, 8);
    if (v.length >= 5) {
      elem.value = `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
      cursorPos = inputValuelength > dobPreValuelength ? cursorPos + 1 : cursorPos;
    } else if (v.length >= 3) {
      elem.value = `${v.slice(0, 2)}/${v.slice(2)}`;
      cursorPos = inputValuelength > dobPreValuelength ? cursorPos + 1 : cursorPos;
    } else {
      elem.value = v;
    }
  }
  if (elem.setSelectionRange) {
    elem.setSelectionRange(cursorPos, cursorPos);
  }
  dobPreValue = elem.value;
}

function setDOBValue(txtDOB, datepickerDOB) {
  var hdnDOB = datepickerDOB;
  if (validateDate(txtDOB, datepickerDOB)) {
    var dobArray = txtDOB.value.split("/");
    hdnDOB.value = dobArray[2] + '-' + dobArray[1] + '-' + dobArray[0] //re-arranged date as 'yyyy-mm-dd';
    ValidationRules.dobValidation(txtDOB, datepickerDOB);
    return null;
  } else {
    hdnDOB.value = txtDOB.value;
  }
}

//Validation Object
var ValidationRules = {
  dobValidation: (txtDOB, datepickerDOB) => {
    showOrHideError(false, datepickerDOB);
    var errorMessage = $(datepickerDOB).attr("data-val-timespan");
    //Age Validations
    var birthDate = new Date($(datepickerDOB).val());
    // get difference from current date;
    var difference = Date.now() - birthDate.getTime();
    var ageDate = new Date(difference);
    var calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (errorMessage !== undefined && (dateRegEx.test($(datepickerDOB).val()) == false || calculatedAge < 18 || difference < 0 || calculatedAge > 130)) {
      var invalidInput = $(datepickerDOB).val().trim() !== '' ? ("\r\nInvalid Input: '" + $(datepickerDOB).val() + "'.") : ""
      txtDOB.value = '';
      $(datepickerDOB).val('');     
      if (errorMessage !== undefined && errorMessage.charAt(errorMessage.length - 1) != ".") {
        errorMessage = errorMessage + "."
      }
      showOrHideError(true, datepickerDOB, errorMessage + invalidInput);
    } else {
      showOrHideError(false, datepickerDOB);
    }
  }
};

function showOrHideError(show, datepickerDOB, message = '') {
  var parentSpan = $("span[data-valmsg-for='" + $(datepickerDOB).attr('name') + "']");
  parentSpan.empty();
  if (show === true) {
    var messageSpan = $('<span id="' + $(datepickerDOB).attr('id') + '-error" ' +
      'class= "field-validation-error" >' + message + '</span > ')
    parentSpan.append(messageSpan)
  }
}

function validateDate(txtDOB, datepickerDOB) {
  var dobArray = txtDOB.value.split("/");
  if (dobArray.length === 1 && dobArray[0] === '') {
    var errmsg = $(datepickerDOB).attr("data-val-required") !== '' ?
      $(datepickerDOB).attr("data-val-required")
      : ($(datepickerDOB).siblings('label.control-label').text() + ' is required.');
    showOrHideError(true, datepickerDOB, errmsg);
    return false;
  }
  var isValid = dobArray[0] && dobArray[1] && dobArray[2] ? true : false;
  isValid = isValid === true ? (dobArray[2].length === 4 && dobArray[1].length === 2 && dobArray[0].length === 2 ? true : false) : false;
  isValid = isValid === true ? (parseInt(dobArray[1]) > 12 ? false : true) : false;
  isValid = isValid === true ? (dobArray[1] === "02" && parseInt(dobArray[2]) % 4 !== 0 && parseInt(dobArray[0]) > 28 ? false : true) : false;
  isValid = isValid === true ? (dobArray[1] === "02" && parseInt(dobArray[2]) % 4 === 0 && parseInt(dobArray[0]) > 29 ? false : true) : false;
  isValid = isValid === true ? ((dobArray[1] === "04" || dobArray[1] === "06" || dobArray[1] === "09" || dobArray[1] === "11")
    && parseInt(dobArray[0]) > 30 ? false : true) : false;
  isValid = isValid === true ? ((dobArray[1] === "01" || dobArray[1] === "03" || dobArray[1] === "05" || dobArray[1] === "07"
    || dobArray[1] === "08" || dobArray[1] === "10" || dobArray[1] === "12")
    && parseInt(dobArray[0]) > 31 ? false : true) : false;
  if (!isValid) {
    showOrHideError(true, datepickerDOB, $(datepickerDOB).attr("data-val-date"));
    return false;
  }
  var dobDt = Date.parse(dobArray[2] + '-' + dobArray[1] + '-' + dobArray[0]); //re-arranged date as 'yyyy-mm-dd'
  if (isNaN(dobDt)) {
    showOrHideError(true, datepickerDOB, $(datepickerDOB).attr("data-val-date"));
    return false;
  }
  showOrHideError(false, datepickerDOB);
  return isValid;
}

export default renderFields;
